import Vue from 'vue';
import Router from 'vue-router';
import authenticator from '@/authenticator/token';

import Login from '@/views/Login/Index';
import Reset from '@/views/Login/Reset';
import Logout from '@/views/Login/Logout';
import Change from '@/views/Login/ChangePassword';
import Users from '@/views/Users';
import Groups from '@/views/Groups';
import Settings from '@/views/Settings';
import Discover from '@/views/Discover';
import Themes from '@/views/Themes';
import Publish from '@/views/Publish';

import Accept from '@/views/Proxy/Accept';

import Forbidden from '@/views/System/403';

import Dashboard from './views/Dashboard/Dashboard';
import Calendar from './views/Calendar/Calendar';
import Wrapper from './components/layouts/Wrapper/Wrapper';
import Register from './views/Register/Register/Register';
import RegisterThemes from './views/Register/RegisterThemes/RegisterThemes';
import RegisterAvatar from './views/Register/RegisterAvatar/RegisterAvatar';
import SocialAccounts from './views/SocialAccounts/SocialAccounts';
import Insights from './views/Insights/Insights';

import { isObject } from 'util';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin',
      component: Wrapper,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'discover',
          name: 'discover',
          component: Discover
        },
        {
          path: 'publish',
          name: 'publish',
          component: Publish
        },
        {
          path: 'themes',
          name: 'themes',
          component: Themes
        },
        {
          path: 'users',
          name: 'users',
          component: Users
        },
        {
          path: 'groups',
          name: 'groups',
          component: Groups
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings
        },
        {
          path: 'insights',
          name: 'insights',
          component: Insights
        },
        {
          path: 'social-accounts',
          name: 'social-accounts',
          component: SocialAccounts
        },
        {
          path: '/',
          redirect: 'dashboard'
        }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        hasRedirect: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login/reset',
      name: 'reset',
      component: Reset,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login/reset/change-password',
      name: 'change-password',
      component: Change,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/register/:token',
      name: 'register',
      component: Register,
      meta: { isSystem: true }
    },
    {
      path: '/accept',
      name: 'accept',
      component: Accept,
      meta: { isSystem: true }
    },
    // System paths
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden,
      meta: {
        isSystem: true
      }
    },

    // Redirects
    { path: '/reset', redirect: { name: 'change-password' } },
    { path: '/', redirect: 'login' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.hasRedirect !== false)) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      authenticator
        .check(to.query.token)
        .then(response => {
          next();
        })
        .catch(error => {
          next({ path: '/login' });
        });
    } else {
      authenticator
        .check()
        .then(response => {
          if (to.matched.some(record => record.meta.isSystem)) {
            next();
          } else {
            next({ path: '/admin' });
          }
        })
        .catch(error => {
          next();
        });
    }
  } else {
    next();
  }
});

export default router;
